import { Component, ElementRef, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { EditArt } from "../../../../_interfaces/EditArt"
import { IonContent, ModalController } from "@ionic/angular"
import { TicketEditService } from "../../../../_provider/ticket-edit.service"
import { DarkmodeService } from '../../../../_provider/darkmode.service';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { ArrowKeysOptions } from 'src/app/_directives/ArrowKeysUseable.directive';
import { transformTreeViewSearch, TreeViewSearch } from 'src/app/_pipes/treeview.pipe';
import { TicketArtEditPage } from 'src/app/_pages/new-settings/ticket-settings/ticket-art-edit/ticket-art-edit.page';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';

@Component({
  selector: 'app-ticket-art-select',
  templateUrl: './ticket-art-select.page.html',
  styleUrls: ['./ticket-art-select.page.scss'],
})
export class TicketArtSelectPage implements OnInit {

  @ViewChild('search', {static: true}) searchElement: ElementRef;
  @ViewChild(IonContent, {static: true}) contentRef: IonContent;

  public isEditMode: boolean = false

  public arrowKeysOptions: ArrowKeysOptions = {
    selectedItem: -1,
    mouseOverItem: new EventEmitter<number>(null),
    mouseMove: new EventEmitter<boolean>(null),
    enterPressed: (index: number) =>{
      let list: EditArt[] = transformTreeViewSearch(this.ticketEditSrv.ticketArts, this.ticketEditSrv.ticketArtSearchText)
      this.artClicked(list[index])
    }
  }

  constructor(
    private modelCtrl: ModalController,
    public ticketEditSrv: TicketEditService,
    public darkmode: DarkmodeService,
    private feedback: FeedbackService
  ) { }

  ngOnInit() {
  }

  ionViewDidEnter(){
    this.arrowKeysOptions.ionContent = this.contentRef
    setTimeout(() => this.searchElement.nativeElement.focus(), 100);
  }

  public async artClicked(art: EditArt){
    if(this.isEditMode) await this.edit(false, art)
    else{
      this.ticketEditSrv.ticketArtSearchText = ""
      await this.feedback.hideKeyboardOnIOS()
      await this.modelCtrl.dismiss(art)
    }
  }

  public async close(){
    this.ticketEditSrv.ticketArtSearchText = ""
    await this.feedback.hideKeyboardOnIOS()
    await this.modelCtrl.dismiss()
  }

  public resetSelectedItem(event: KeyboardEvent){
    if (!(event.key == "ArrowUp" || event.key == "ArrowDown" || event.key == "Enter")) this.arrowKeysOptions.selectedItem = -1
  }

  public async edit(isNew: boolean, art?: EditArt){
    await this.feedback.openModal(TicketArtEditPage, {isNew: isNew, currentArt: art}, (result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return
      var newList = [...this.ticketEditSrv.ticketArts]
      this.ticketEditSrv.ticketArts = []
      setTimeout(() => this.ticketEditSrv.ticketArts = [...newList], 0);
    })
  }
}
